import axios from 'axios';
import { LTI_1P3_PUT_ASSIGNMENT } from '../../constants/endpoints';

const updateLti1p3Assignment = (spaceId, assignmentId, assignmentData) =>
  axios.put(LTI_1P3_PUT_ASSIGNMENT({ spaceId, assignmentId }), assignmentData, {
    withCredentials: true,
  });

export default updateLti1p3Assignment;
